module.exports = __webpack_public_path__ + "static/media/Logo GameQuiz png-01.6834843a.png";